import { DateTime } from 'luxon';
import createDateTime from './dateParser';

const formatHours = (datetime: DateTime, tz?: string) => {
  const formattedTime = datetime
    .toLocaleString({
      hour12: true,
      hour: 'numeric',
      minute: 'numeric',
    })
    .toUpperCase();

  return `${formattedTime}${tz ? ` ${tz}` : ''}`;
};

export const completeDateIn12HoursFormat = (date: Date | string | DateTime) => {
  const dateTime = createDateTime(date);

  return dateTime.toLocaleString({
    hour12: true,
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    year: 'numeric',
  });
};

export const dateTo12HoursFormat = (
  date: Date | string | DateTime,
  timezone?: string,
  shortTZ?: string // if present, will be included in the output
): string => {
  if (typeof date === 'string') {
    const parsed = DateTime.fromISO(date, { setZone: true });
    return formatHours(timezone ? parsed : parsed.toLocal(), shortTZ);
  }
  if (date instanceof DateTime) {
    return formatHours(date, shortTZ);
  }
  let datetime = createDateTime(date);
  if (timezone) datetime = datetime.setZone(timezone);
  return formatHours(datetime, shortTZ);
};
